<section class="edit-section">
  <bodyanalytics-section-rule [label]="label()"></bodyanalytics-section-rule>
  <div
    class="edit-section__grid"
    [style.grid-template-columns]="'repeat(' + columns() + ', minmax(0, 1fr))'"
  >
    <ng-content></ng-content>
  </div>
</section>
